<script>
import Vue from "vue";
export default {
  namespaced: true,
  state: {
    target_Delete: {},
    target_Edit: {}
  },
  mutations: {
    set_Delete(state, want_Delete_Ivent) {
      Vue.set(state.target_Delete, "id", want_Delete_Ivent.id);
      Vue.set(state.target_Delete, "name", want_Delete_Ivent.data().name);
    },
    open_Edit(state, want_Edit_Ivent) {
      Vue.set(state.target_Edit, "id", want_Edit_Ivent.id);
      Vue.set(state.target_Edit, "name", want_Edit_Ivent.data().name);
      Vue.set(state.target_Edit, "date", want_Edit_Ivent.data().date.toDate());
    }
  },
  actions: {
    display_Delete({ commit }, target_ivent) {
      commit("set_Delete", target_ivent);
    },
    display_Edit({ commit }, target_ivent) {
      commit("open_Edit", target_ivent);
    }
  },
  getters: {
    edit(state) {
      return state.target_Edit;
    },
    delete(state) {
      return state.target_Delete;
    }
  }
};
</script>
